import { Typography } from '@mui/material';
import DOMPurify from 'dompurify';
import React from 'react';

import getTextTruncationSx from '../../../../../utils/getTextTruncationSx';

const MuiCardBaseShortDescription: React.FC<{
	description?: string;
	truncateDescriptionAt?: number;
}> = ({ description, truncateDescriptionAt }) => {
	const truncateSx = truncateDescriptionAt ? getTextTruncationSx(truncateDescriptionAt) : {};

	return description ? (
		<Typography
			variant="body2"
			color="text.secondary"
			sx={truncateSx}
			// biome-ignore lint/security/noDangerouslySetInnerHtml: pre-existing raw-HTML rendering of editor/CMS-produced content
			dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
		/>
	) : null;
};

export default MuiCardBaseShortDescription;
